import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Icons} from "../../../model/icon";
import {IconComponent} from "../icon/icon.component";
import {NgClass} from '@angular/common';
import {ThemeService} from '../../../services/theme.service';

@Component({
  selector: 'app-arrow',
  imports: [
    IconComponent,
    NgClass
  ],
  templateUrl: './arrow.component.html',
  styleUrl: './arrow.component.scss',
  standalone: true
})
export class ArrowComponent {
  constructor(public themeService: ThemeService) {}

  @Input() right: boolean = false;
  @Output() emitClick: EventEmitter<any> = new EventEmitter();

  getInvert() {
    return this.themeService.getTheme() == 'black-theme';
  }

    protected readonly Icons = Icons;
}
